export const initialState = {
  data: [],
  error: false,
  isFetched: false,
  isFetching: false,
  messages: {}
}

export const ACTION_TYPES = {
  YEARS_REQUEST: 'YEARS_REQUEST',
  YEARS_SUCCESS: 'YEARS_SUCCESS',
  YEARS_ERROR: 'YEARS_ERROR',
  YEARS_CLEAR: 'YEARS_CLEAR'
}

export const getYearsIncomeReport = (payload = {}) => ({
  type: ACTION_TYPES.YEARS_REQUEST,
  payload
})

export const clearYearsIncomeReport = () => ({
  type: ACTION_TYPES.YEARS_CLEAR
})

const yearsIncomeReport = (state = initialState, { type, payload }) => {
  switch (type) {
    case ACTION_TYPES.YEARS_REQUEST:
      return {
        ...state,
        isFetching: true
      }
    case ACTION_TYPES.YEARS_SUCCESS:
      return {
        ...state,
        data: payload.data,
        error: false,
        isFetched: true,
        isFetching: false,
        messages: payload.messages
      }
    case ACTION_TYPES.YEARS_ERROR:
      return {
        ...state,
        error: true,
        isFetched: true,
        isFetching: false
      }
    case ACTION_TYPES.YEARS_CLEAR:
      return {
        ...initialState
      }
    default:
      return state
  }
}

export default yearsIncomeReport
